// Fades `.fade-item` elements in when they enter the viewport and out again once
// they have left it completely. The CSS does the fading:
// `.fadingitems .fade-invisible { opacity: 0 }` plus a transition on `.fade-item`.

const INVISIBLE = 'fade-invisible';

const inViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
};

export default function fadeInvisible() {
    const items = document.querySelectorAll('.fade-item');

    // The observer reports asynchronously: mark items already in view first, so
    // they don't flash invisible when fading is switched on.
    items.forEach((el) => el.classList.toggle(INVISIBLE, !inViewport(el)));
    document.body.classList.add('fadingitems');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.target.classList.toggle(INVISIBLE, !entry.isIntersecting));
    });
    items.forEach((el) => observer.observe(el));
}
